module.exports = __webpack_public_path__ + "static/img/TY.37880ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TY.png
// module id = J9qe
// module chunks = 18